import HeroVariant from './hero-variant'

export default HeroVariant
